<template>
	<v-dialog v-model="dialog" max-width="600">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-calculator</v-icon>
				在庫数調整
			</v-btn>
		</template>
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 在庫数調整 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<div>
					<!-- TODO -->
					<table width="100%" class="show-dialog-table">
						<tbody>
							<ShowDetailRecord :columnName="'現状在庫数'" :value="'XXX'" />
							<ShowDetailRecord :columnName="'内 引当済数'" :value="'XXX'" />
							<ShowDetailRecord :columnName="'引当可能数'" :value="'XXX'" />
						</tbody>
					</table>
					<template v-if="type == 'rubber'">
						<table width="100%" class="my-4 show-dialog-table show-dialog-table--form">
							<tbody>
								<ShowDetailRecord :columnName="'新品長さ'">
									<template v-slot:value>
										<v-text-field
											v-model="TODO"
											background-color="white"
											:rules="[rules.required]"
											dense
											outlined
											hide-details
										/>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :columnName="'新品本数'">
									<template v-slot:value>
										<v-text-field
											v-model="TODO"
											background-color="white"
											:rules="[rules.required]"
											dense
											outlined
											hide-details
										/>
									</template>
								</ShowDetailRecord>
								<!-- v-for="( 使いさし, i) in 全使いさし" :key="i" -->
								<ShowDetailRecord :columnName="'使いさし本数(長さ:XX m)'">
									<template v-slot:value>
										<v-text-field
											v-model="TODO"
											background-color="white"
											:rules="[rules.required]"
											dense
											outlined
											hide-details
										/>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
						<ConstructionPartiallyUsedNewDialog :type="type" />
					</template>

					<table
						v-if="type == 'item_kg'"
						width="100%"
						class="mt-4 show-dialog-table show-dialog-table--form"
					>
						<tbody>
							<ShowDetailRecord :columnName="'新缶入り目'">
								<template v-slot:value>
									<v-text-field
										v-model="TODO"
										background-color="white"
										:rules="[rules.required]"
										dense
										outlined
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'新缶数'">
								<template v-slot:value>
									<v-text-field
										v-model="TODO"
										background-color="white"
										:rules="[rules.required]"
										dense
										outlined
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'使いさし重量'">
								<template v-slot:value>
									<v-text-field
										v-model="TODO"
										background-color="white"
										:rules="[rules.required]"
										dense
										outlined
										hide-details
									/>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
					<table
						v-if="type == 'item_quantity'"
						width="100%"
						class="mt-4 show-dialog-table show-dialog-table--form"
					>
						<tbody>
							<ShowDetailRecord :columnName="'在庫数'">
								<template v-slot:value>
									<v-text-field
										v-model="TODO"
										background-color="white"
										:rules="[rules.required]"
										dense
										outlined
										hide-details
									/>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
					<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
						<tbody>
							<ShowDetailRecord :columnName="'変更理由'">
								<template v-slot:value>
									<v-textarea
										v-model="TODO"
										background-color="white"
										:rules="[rules.required]"
										rows="1"
										auto-grow
										dense
										outlined
										hide-details
									/>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
				</div>
			</div>
			<v-card-actions>
				<v-row no-gutters>
					<v-col sm="2" cols="0" />
					<v-col sm="8" cols="12" class="text-center">
						<v-btn color="secondary" @click="updateStock">
							<v-icon class="mr-1">mdi-pencil</v-icon>
							変更する
						</v-btn>
					</v-col>
					<v-col sm="2" cols="0" class="text-right">
						<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="closeDialog">
							キャンセル
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import ConstructionPartiallyUsedNewDialog from "./ConstructionPartiallyUsedNewDialog.vue"

export default {
	props: {
		type: {
			type: String,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
		ConstructionPartiallyUsedNewDialog,
	},
	data() {
		return {
			rules,
			dialog: false,
			TODO: null,
		}
	},
	methods: {
		updateStock() {
			// TODO:
			this.$emit("update-item", this.TODO)
			this.closeDialog()
		},
		closeDialog() {
			this.dialog = false
		},
	},
}
</script>